import React from 'react';

import { LANG_LEVEL_TO_ICON_NAME, LanguageLevelInt } from 'constants/languageLevels';
import Icon from 'components/Icon';
import Typography from 'components/ui/Typography';

import css from './LanguageSelectChipContent.module.scss';

interface Props {
    languageName: string;
    level: LanguageLevelInt;
}

const LanguageSelectChipContent: React.FC<Props> = ({ languageName, level }) => {
    return (
        <div className={css.content}>
            <Typography color="gray">{languageName}</Typography>
            <Icon name={LANG_LEVEL_TO_ICON_NAME[level]} width={20} color={level === 4 ? 'green' : 'orange'} />
        </div>
    );
};

export default LanguageSelectChipContent;
